/**
 * The wall slots — a siding template's sections.
 *
 * Measured off `job_wall_measurements` rather than the roof (siding.ts).
 * Jonathon, 2026-09-30: "there will be different fields for wall measurements
 * than roof measurements." Paired like the roof's, so a gable vent or a dryer
 * vent has an "ea" section to sit in. Kept in a file of their own only for
 * length; `ROOF_SLOTS` spreads them in, and `roofSlot` finds them.
 */

import type { RoofSlot, RoofSlotMeasurement } from "./roofSlots.js";

/** A wall section and its "ea" twin. See `noWaste` for the flag. */
const wallPair = (
  key: string,
  label: string,
  measurement: RoofSlotMeasurement,
  noWaste = false,
): RoofSlot[] => [
  { key, label: `${label} products`, measurement, surface: "wall", noWaste },
  {
    key: `${key}_ea`,
    label: `${label} products ea`,
    measurement: null,
    surface: "wall",
  },
];

export const WALL_SLOTS: readonly RoofSlot[] = [
  ...wallPair("siding", "Siding", "siding_squares"),
  ...wallPair(
    "siding_removal",
    "Siding tear-off",
    "siding_removal_squares",
    true,
  ),
  ...wallPair("house_wrap", "House wrap", "house_wrap_squares"),
  ...wallPair("outside_corner", "Outside corner", "outside_corner_posts", true),
  ...wallPair("inside_corner", "Inside corner", "inside_corner_posts", true),
  ...wallPair("j_channel", "J channel", "j_channel_lf"),
  ...wallPair("siding_starter", "Siding starter", "siding_starter_lf"),
  ...wallPair("openings", "Window & door", "openings_ea", true),
  ...wallPair("soffit", "Soffit (by the foot)", "soffit_lf"),
  ...wallPair("soffit_area", "Soffit (by area)", "soffit_squares"),
  ...wallPair("fascia", "Fascia", "fascia_lf"),
  ...wallPair("frieze", "Frieze board", "frieze_lf"),
];
